import { useSearchParams } from 'next/navigation';

import { SubHeadline } from '~components/Typography';
import { useRetainedValue } from '~hooks/useRetainedValue';
import { useTranslations } from '~i18n/hooks';
import { usePathname, useRouter } from '~i18n/navigation';
import { ButtonSecondary } from '~shared/ui/atoms/Buttons/ButtonSecondary';
import { updateQueryParamsWithPathname } from '~utils/searchParams';

import type { BotWizardValues } from '../../model/types';
import { WorkingArea } from '../styles';
import { ButtonsWrapper, StyledChooseSteps } from './styles';

export const ChooseSteps = ({ values }: { values: BotWizardValues }) => {
	const pathname = usePathname();

	const router = useRouter();
	const t = useTranslations('BotWizard');
	const searchParams = useSearchParams();

	const [value, setValue] = useRetainedValue(
		values.path as string | undefined,
		(v) => {
			router.push(
				updateQueryParamsWithPathname({ path: v }, pathname, searchParams)
			);
		}
	);
	return (
		<WorkingArea>
			<StyledChooseSteps>
				<SubHeadline>{t('pathsTitle')}</SubHeadline>
				<ButtonsWrapper>
					<ButtonSecondary
						onClick={() => setValue('0')}
						selected={value === '0'}
						size="L"
					>
						{t('presetsPathButton')}
					</ButtonSecondary>
					<ButtonSecondary
						onClick={() => setValue('1')}
						selected={value === '1'}
						size="L"
					>
						{t('promptPathButton')}
					</ButtonSecondary>
				</ButtonsWrapper>
			</StyledChooseSteps>
		</WorkingArea>
	);
};
